import hamburger from './HamburgerMenu.svg'
import envelope from './Envelope.png'
import React from 'react';

const styles = {
  shareContainer: {
    flexDirection: 'column',
    display: 'flex',
    marginLeft: '25%',
    marginRight: '25%'
  },
  shareMenu: {
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 100,
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    display: 'flex'
  },
  envelopeImage: {
    height: 'auto',
    width: '80%',
  },
  menuIcon: {
    width: '80px',
    height: '80px',
    position: 'absolute',
    top: 0,
    right: 0,
    margin: 20
  },
}

function Share() {
  return (
    <div style={styles.shareContainer}>
      <div style={styles.shareMenu}>
        <a href='/menu'>
          <img src={hamburger} style={styles.menuIcon} />
        </a>
        <img src={envelope}
          style={styles.envelopeImage}
        />
        <h1>Share Your Story</h1>
        <p>
          Coming Soon!
        </p>
      </div>
    </div>
  )
}

export default Share;
